import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import Provider from 'models/productManagement/provider/Model.Provider';
import StatementEmailTemplate from '../statementEmailTemplate/Model.StatementEmailTemplate';
import providerStatementEmailTemplateListApi from './list/Api.ProviderStatementEmailTemplate.List';
import providerStatementEmailTemplateSaveApi from './save/Api.ProviderStatementEmailTemplate.Save';
import providerStatementEmailTemplateDeleteApi from './delete/Api.ProviderStatementEmailTemplate.Delete';
import ProviderStatementEmailTemplateAttachment from '../providerStatementEmailTemplateAttachment/Model.ProviderStatementEmailTemplateAttachment';

export default class ProviderStatementEmailTemplate
  extends Model<Model.IProviderStatementEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProviderStatementEmailTemplate>
{
  id: number;
  name: string;
  statementStatusTrigger: Model.Enum.StatementStatusCode;
  senderEmail: string;
  senderName: string;
  sendToRepresentative: boolean;
  sendToDealersAccounting: boolean;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];
  additionalRecipientEmails: string[] = [];
  attachments?: ProviderStatementEmailTemplateAttachment[];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  statementEmailTemplate: StatementEmailTemplate;
  statementEmailTemplateId: number;
  provider: Provider;
  providerId: number;

  constructor(
    data: Partial<Model.IProviderStatementEmailTemplate> | Utils.FormData<Model.IProviderStatementEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
        attachments: [ProviderStatementEmailTemplateAttachment],
        provider: Provider,
        statementEmailTemplate: StatementEmailTemplate,
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ProviderStatementEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await providerStatementEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ProviderStatementEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await providerStatementEmailTemplateSaveApi(this);
  }
  async delete() {
    return await providerStatementEmailTemplateDeleteApi(this.id);
  }
}
